import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import presentationService from "../services/presentation";

const initialState = {
  presentations: []
}

export const getPresentation = createAsyncThunk(
  "presentation/get",
  async () => {
    const res = await presentationService.getPresentations();
    return res.data;
  }
)

export const createPresentation = createAsyncThunk(
  "presentation/create",
  async (info) => {
    const res = await presentationService.createPresentation(info);
    return res.data;
  }
)

export const updatePresentation = createAsyncThunk(
  "presentation/update",
  async (info) => {
    const res = await presentationService.updatePresentation(info);
    return res.data;
  }
)

export const schedulePresentation = createAsyncThunk(
  "presentation/schedule",
  async (info) => {
    const res = await presentationService.schedulePresentation(info);
    return res.data;
  }
)

export const deletePresentation = createAsyncThunk(
  "presentation/delete",
  async (info) => {
    const {id} = info;
    const res = await presentationService.deletePresentation(info);
    return {
      id,
      success: res.data
    };
  }
)
export const generatePresentation = createAsyncThunk(
  "presentation/generate",
  async (info) => {
    const {id} = info;
    const res = await presentationService.generatePresentation(info);
    return {
      id,
      success: res.data
    };
  }
)

export const createSlide = createAsyncThunk(
  "presentation/slide/create", 
  async (info) => {
    const {presentation} = info;
    const res = await presentationService.createSlide(info);
    return {
      presentation,
      data: res.data
    };
  }
)

export const updateSlide = createAsyncThunk(
  "presentation/slide/update", 
  async (info) => {
    const {presentation} = info;
    const res = await presentationService.updateSlide(info);
    return {
      presentation,
      data: res.data
    };
  }
)

export const deleteSlide = createAsyncThunk(
  "presentation/slide/delete", 
  async (info) => {
    const {id, index} = info;
    const res = await presentationService.deleteSlide(info);
    return {
      id,
      index,
      success: res.data
    };
  }
)


export const moveSlide = createAsyncThunk(
  "presentation/slide/move", 
  async (info) => {
    const {sourceId, sourceIndex, destinationId, destinationIndex} = info;
    const res = await presentationService.moveSlide(info);
    return {
      sourceId, 
      sourceIndex, 
      destinationId, 
      destinationIndex,
      success: res.data
    };
  }
)

const presentationSlice = createSlice({
  name: "presentation",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getPresentation.fulfilled, (state, action) => {
      state.presentations = action.payload;
    })
    builder.addCase(createPresentation.fulfilled, (state, action) => {
      const {id, title, model, items} = action.payload;
      state.presentations.push({
        id,
        title,
        model,
        items
      });
    })
    builder.addCase(updatePresentation.fulfilled, (state, action) => {
      const {id, title, model, items} = action.payload;
      const newPresentation = state.presentations.map(presentation => {
        if(presentation.id === id) 
          return {
            id, 
            title,
            model,
            items
          }
        return presentation;
      });
      state.presentations = newPresentation

    })
    builder.addCase(deletePresentation.fulfilled, (state, action) => {
      const {id, success} = action.payload;
      const updatedPres = state.presentations.filter(item => item.id !== id);
      if(success) state.presentations = updatedPres;
    })
    builder.addCase(generatePresentation.fulfilled, (state, action) => {
      
    })
    builder.addCase(schedulePresentation.fulfilled, (state, action) => {
      
    })
    builder.addCase(createSlide.fulfilled, (state, action) => {
      const {presentation, data: {title, model, items}} = action.payload;
      let itemJson = JSON.parse(items);
      const updatedPres = state.presentations.map(item => {
        if(item.id === presentation)
          return {
            id: presentation,
            title,
            model,
            items: itemJson
          }
        else
          return item
      })
      state.presentations = updatedPres;
    })
    builder.addCase(updateSlide.fulfilled, (state, action) => {
      const {presentation, data: {title, model, items}} = action.payload;
      let itemJson = JSON.parse(items);
      const updatedPres = state.presentations.map(item => {
        if(item.id === presentation)
          return {
            id: presentation,
            title,
            model,
            items: itemJson
          }
        else
          return item
      })
      state.presentations = updatedPres;
    })
    builder.addCase(moveSlide.fulfilled, (state, action) => {
      const {sourceId, sourceIndex, destinationId, destinationIndex, success} = action.payload
      console.log(action.payload)
      const source = {
        droppableId: sourceId,
        index: sourceIndex
      }
      const destination = {
        droppableId: destinationId,
        index: destinationIndex
      }
      if( success ) {
        const sourceIndex = state.presentations.findIndex(
          item => item.id === source.droppableId
        );
        const destinationIndex = state.presentations.findIndex(
          item => item.id === destination.droppableId
        );
        if(source.droppableId !== destination.droppableId){
          const dragCard = state.presentations[sourceIndex].items[source.index]
          const newSourceItems = state.presentations[sourceIndex].items.filter((item, index) => index !== source.index);
          let newDestinationItems = [];
  
          for(let i=0;i<destination.index;i++)
            newDestinationItems.push(state.presentations[destinationIndex].items[i])
          newDestinationItems.push(dragCard)
          for(let i=destination.index;i<state.presentations[destinationIndex].items.length;i++)
            newDestinationItems.push(state.presentations[destinationIndex].items[i])
          
          const newPresentation = state.presentations.map(presentation => {
            if(presentation.id === source.droppableId)
              return {
                ...presentation,
                items: newSourceItems
              }
            else if(presentation.id === destination.droppableId) 
              return {
                ...presentation,
                items: newDestinationItems
              }
            return presentation;
          })
          state.presentations = newPresentation;
        }
        else {
          let newItems = state.presentations[sourceIndex].items;
          let temp = newItems[source.index];
          newItems[source.index] = newItems[destination.index];
          newItems[destination.index] = temp;
          const newPresentation = state.presentations.map(item => {
            if(item.id === sourceId) 
              return {
                ...item,
                items: newItems
              }
            return item;
          });

          state.presentations = newPresentation
        }
      }
    })
    builder.addCase(deleteSlide.fulfilled, (state, action) => {
      const {id, index, success} = action.payload;
      if(success) {
        const sourceIndex = state.presentations.findIndex(item => item.id === id);
        const newItems = state.presentations[sourceIndex].items.filter((item, i) => i!==index);
        const newPresentations = state.presentations.map(item => {
          if(item.id === id)
            return {
              ...item,
              items: newItems
            }
          return item;
        })

        state.presentations = newPresentations
      }
    })
  }
});

const { reducer } = presentationSlice;

export default reducer;